import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';
import type { RootState } from '~/store';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ZoneManagementState } from './types';
import { initialZoneManagementState } from './types';

export const zoneManagementSlice = createSlice({
    name: 'zoneManagement',
    initialState: initialZoneManagementState,
    reducers: {
        setIsCreatingZoneFromRoute: (
            state: ZoneManagementState,
            action: PayloadAction<boolean>
        ) => {
            const { payload: isCreatingZoneFromRoute } = action;

            const isValidPayload = typeof isCreatingZoneFromRoute === 'boolean';

            if (!isValidPayload) return state;

            return {
                ...state,
                isCreatingZoneFromRoute
            };
        },
        resetZoneManagement: (): ZoneManagementState => {
            return initialZoneManagementState;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return initialZoneManagementState;
        });
    }
});

export const { setIsCreatingZoneFromRoute, resetZoneManagement } =
    zoneManagementSlice.actions;

export const selectIsCreatingZoneFromRoute = (state: RootState) =>
    state.zoneManagement.isCreatingZoneFromRoute;

export default zoneManagementSlice.reducer;
